import { GeneralContentPage } from "api"
import { useIsDesktop } from "common/MediaQueries"
import StickyImagePageLayout from "common/StickyImagePageLayout"
import styled from "styled-components"
import Description from "../../common/Description"

const StyledDescription = styled.div`
  font-size: 14px;
  line-height: 22px;
  padding-bottom: 100px;
  color: ${(p) => p.theme.colors.black};
  white-space: break-spaces;
  overflow-x: auto;
  h2 {
    strong {
      font-size: 16px;
      font-weight: normal;
    }

    margin-bottom: 20px;
  }

  p {
    margin: 0;
  }

  ul {
    margin: 0.5em 0;
    padding-inline-start: 1.3em;
    li::marker {
      color: ${({ theme }) => theme.colors.red};
    }
  }
  a {
    text-decoration: underline;
  }
  ${(p) => p.theme.breakpoints.down("sm")} {
    table {
      word-break: break-word;
      width: 100% !important;
    }

    td {
      padding: 0 5px;
      width: auto !important;
      min-width: 75px;
    }
  }
`

export interface TemplatePageProps {
  data: GeneralContentPage
}

const TemplatePage = (props: TemplatePageProps): JSX.Element => {
  const { data } = props
  const isDesktop = useIsDesktop()

  const image = isDesktop ? data?.main?.logoDesktop : data?.main?.logoMobile
  const poster = data.main?.poster
  //Render
  return (
    <StickyImagePageLayout
      imageUrl={image?.media?.publicUrl}
      altText={image?.media?.altText}
      type={image?.media?.type}
      poster={poster?.media?.publicUrl}
    >
      <div>
        <Description
          data={{
            title: data?.navigationTitle,
            subtitle: data?.main?.subtitle?.value,
            description: null,
          }}
          parentPageType="investments"
        />
        <StyledDescription
          dangerouslySetInnerHTML={{ __html: data?.main?.text?.value }}
        ></StyledDescription>
      </div>
    </StickyImagePageLayout>
  )
}

export default TemplatePage
